import React from 'react'
import FooterLayout from '../FooterLayout'

const MasterCreationFooter = ({ createMasterEnabled, isView }) => {
    let fields = [
        { id: "1", name: "Quit", shortcutKey: "Esc", type: 'button', line: '', isDisabled: false },
        { id: "2", name: "", shortcutKey: "", type: 'button', line: '', isDisabled: false },
        { id: "3", name: "", shortcutKey: "", type: 'button', line: '', isDisabled: false },
        { id: "4", name: "Accept", shortcutKey: "A", type: 'submit', line: 'double', isDisabled: false, },
        { id: "5", name: "Create Master", shortcutKey: "C", type: 'button', line: 'single', isDisabled: !createMasterEnabled },
        { id: "6", name: "", shortcutKey: "", type: 'button', line: '', isDisabled: false },
        { id: "7", name: "", shortcutKey: "", type: 'button', line: '', isDisabled: false },
        { id: "8", name: "", shortcutKey: "", type: 'button', line: '', isDisabled: false },
        { id: "9", name: "", shortcutKey: "", type: 'button', line: '', isDisabled: false },
        { id: "10", name: "", shortcutKey: "", type: 'button', line: '', isDisabled: false },
    ]

    if (isView) {
        fields = fields.map(field => {
            if (['Accept', 'Create Master'].includes(field.name)) {
                return { ...field, name: "", shortcutKey: "", line: "", type: "button", isDisabled: true };
            }
            return field;
        });
    }
    return (
        <div className='tomasterfooter'>
            <div className='footer'>
                {
                    fields.map((item, index) => {
                        return (
                            <FooterLayout key={item.id} fields={item} />
                        )
                    })
                }

            </div>
        </div>
    )
}

export default MasterCreationFooter
